"use client";
import React, { useEffect, useState } from "react";
import StocksRight from "./stocksRight/StocksRight";
import hdfc from "../../images/hdfc.png";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { PieChart } from "@carbon/charts-react";
import axios from "axios";
import NoDataFound from "../../components/NoDataFound";
import ImageLoading from "../../components/ImageLoading";
import Avatar from "react-avatar";

const Stocks = ({ id, setSingleStocks, setStocksId, stocksId }) => {
  const token = localStorage.getItem("token");
  const options = {
    method: "GET",
    headers: { Authorization: token },
  };
  // const { id } = useParams();
  const navigate = useNavigate();
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedInstitution, setSelectedInstitution] = useState("all");
  const [selectedInstitutionBottom, setSelectedInstitutionBottom] =
    useState("all");
  const [isExpanded, setIsExpanded] = useState(false);
  const [stockValuation, setStockValuation] = useState("undervalued");
  const [selectedStock, setSelectedStock] = useState(null);
  const [selectedPEStock, setSelectedPEStock] = useState(null);

  const [highlowselected, setHighLowSelected] = useState("high");

  const [chartDataError, setChartDataError] = useState(false);

  const [stocksInfo, setStocksInfo] = useState("");

  const [keyInfo, setKeyInfo] = useState("");
  const [basicGraph, setBasicGraph] = useState("");
  const [longGraph, setLongGraph] = useState("");
  const [assetAllocationData, setAssetAllocationData] = useState("");

  // const [stocksInfo, setStocksInfo] = useState({
  //   stock_details: {
  //     stock_name: "Tata Consultancy Services Ltd",
  //     as_on_date: "2024-08-22",
  //     nav: 4499.95,
  //     per_day_value: -51.75,
  //     per_day_percent: -1.14,
  //     about_stock: "NA",
  //     stock_logo: "NA",
  //   },
  // });
  const [shareHoldingGraph, setShareHoldingGraph] = useState("");

  const getStockDetails = async () => {
    setLoading(true);
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/cmots/stock_details?isin_no=${stocksId}`,
        options
      );
      const res1 = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/cmots/share_holding_pattern?isin_no=${stocksId}`,
        options
      );
      // const res2 = await axios.request(
      //   `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/get_long_nav?isinno=${mfid}`,
      //   options
      // );
      // const res3 = await axios.request(
      //   `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/asset_allocation?isinno=${mfid}`,
      //   options
      // );
      console.log("res?.data", res?.data);
      setStocksInfo(res?.data?.data);
      setShareHoldingGraph(res1?.data?.data);
      // setLongGraph(res2?.data?.response);
      // setAssetAllocationData(res3?.data?.response);
      setNoData(false);
      setLoading(false);
    } catch (error) {
      // setNoData(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    getStockDetails();
  }, [stocksId]);

  const handleHighLowClick = (pe) => {
    setHighLowSelected(pe);
  };
  const handleDropdownChange = (event) => {
    setSelectedInstitution(event.target.value);
  };
  const handleDropdownBottomChange = (event) => {
    setSelectedInstitutionBottom(event.target.value);
  };

  const handleStockClick = (stock) => {
    setSelectedStock(stock);
  };
  const handleStockClickFromPE = (peStock) => {
    console.log(peStock);
    setSelectedPEStock(peStock);
  };
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const handleStocksValuation = (value) => {
    setStockValuation(value);
  };
  useEffect(() => {
    if (selectedPEStock) {
      setSelectedStock(selectedPEStock);
    }
  }, [selectedPEStock]);

  useEffect(() => {
    // Set the initial selected stock to the first stock in the list
    if (res?.stocks?.length > 0) {
      setSelectedStock(res.stocks[0]);
    }
  }, []);

  const res = {
    Score: [
      {
        beta: [
          { institutionName: "grow", betaValue: "14.78" },
          { institutionName: "zerodha", betaValue: "15.78" },
          { all: [{ betaValue: "17.00" }] },
        ],
        portfolio: [
          { institutionName: "grow", portfolioValue: "0.82" },
          { institutionName: "zerodha", portfolioValue: "0.78" },
          { all: [{ portfolioValue: "1.00" }] },
        ],
      },
    ],
    stocks: [
      {
        stockName: "HDFC Bank Ltd",
        quantity: "40",
        price: "235",
        currentValue: "35,220",
        institution: "grow",
        pe: "high",
      },
      {
        stockName: "JM Large Cap Fund (Direct) - Growtj",
        quantity: "80",
        price: "23",
        currentValue: "22,220",
        institution: "zerodha",
        pe: "low",
      },
      {
        stockName: "ITC Ltd",
        quantity: "10",
        price: "55",
        currentValue: "18,920",
        institution: "grow",
        pe: "high",
      },
      {
        stockName: "Invesco India LargeEcap Fund Direct Plan Growth",
        quantity: "50",
        price: "45",
        currentValue: "68,220",
        institution: "zerodha",
        pe: "low",
      },
      {
        stockName: "Nippon India Small Cap Fund - Growth Plan Growth Option",
        quantity: "40",
        price: "135",
        currentValue: "28,420",
        institution: "grow",
        pe: "high",
      },
      {
        stockName: "Invesco India Largecap Fund Direct Plan Growth",
        quantity: "30",
        price: "25",
        currentValue: "48,220",
        institution: "zerodha",
        pe: "low",
      },
      {
        stockName: "JM Large Cap Fund (Direct) - Growtj",
        quantity: "440",
        price: "735",
        currentValue: "38,220",
        institution: "grow",
        pe: "high",
      },
      {
        stockName: "HDFC-Bank Ltd",
        quantity: "10",
        price: "215",
        currentValue: "28,220",
        institution: "zerodha",
        pe: "low",
      },
      {
        stockName: "HDFC Bank Ltdevwbve",
        quantity: "15",
        price: "205",
        currentValue: "19,220",
        institution: "grow",
        pe: "high",
      },
      {
        stockName: "HDFC Bank ",
        quantity: "70",
        price: "265",
        currentValue: "18,210",
        institution: "grow",
        pe: "high",
      },
      {
        stockName: "HDFC Bank1Ltd",
        quantity: "9",
        price: "215",
        currentValue: "18,22",
        institution: "zerodha",
        pe: "low",
      },
      {
        stockName: "HDFC Bank3 Ltd",
        quantity: "90",
        price: "285",
        currentValue: "18,20",
        institution: "zerodha",
        pe: "high",
      },
    ],
  };

  const filteredStocks =
    selectedInstitution === "all"
      ? res.stocks
      : res.stocks.filter((stock) => stock.institution === selectedInstitution);

  const filteredResBeta =
    selectedInstitutionBottom === "all"
      ? res?.Score[0]?.beta?.find((beta) => beta.hasOwnProperty("all"))?.all[0]
          ?.betaValue
      : res?.Score[0]?.beta.find(
          (beta) => beta.institutionName === selectedInstitutionBottom
        )?.betaValue;

  const filteredResPortfolio =
    selectedInstitutionBottom === "all"
      ? res?.Score[0]?.portfolio?.find((portfolio) =>
          portfolio.hasOwnProperty("all")
        )?.all[0]?.portfolioValue
      : res?.Score[0]?.portfolio.find(
          (portfolio) => portfolio.institutionName === selectedInstitutionBottom
        )?.portfolioValue;

  const filteredPEStocks = res.stocks.filter(
    (stock) => stock.pe === highlowselected
  );
  const filteredSTocksValuation = res;

  const response = [
    {
      name: "foreign_institution",
      value: 22000,
    },
    {
      name: "domestic_institution",
      value: 53436.4,
    },
    {
      name: "government",
      value: 78400,
    },
    {
      name: "public",
      value: 28400,
    },
  ];
  const updatedResponse = response?.map((item) => {
    let updatedValue;
    switch (item.name) {
      case "domestic_institution":
        updatedValue = "Domestic Institution";
        break;
      case "government":
        updatedValue = "Government";
        break;
      case "public":
        updatedValue = "Public";
        break;
      case "foreign_institution":
        updatedValue = "Foreign Institutions";
        break;
      default:
        updatedValue = item.name;
    }

    return {
      group: updatedValue,
      value: item.value,
    };
  });

  const graphOptions = {
    resizable: true,
    height: "130px",
    pie: {
      innerRadius: 0,
      labels: {
        enabled: true,
      },
    },
    toolbar: {
      enabled: false,
    },
    legend: {
      position: "right",
      alignment: "center",
    },
    color: {
      scale: [
        "#66A9E4",
        "#F7A452",
        "#6C87C8",
        "#26ABA4",
        "#9D53F2",
        "#0070D2",
        "#E8787D",
      ],
    },
  };

  return (
    <>
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {!noData && !loading && (
        <div className="mt-4 w-full overflow-auto h-[calc(100vh-190px)] bg-white rounded">
          {/* Left fixed width part */}
          <div className="flex w-full h-[77vh]">
            <div className="w-[28%]">
              {/* Content for the left part */}
              <div
                className="inline-flex flex-row justify-start items-center gap-2 p-4 cursor-pointer"
                onClick={() => {
                  setStocksId("");
                  setSingleStocks(false);
                }}
              >
                <FaArrowLeft size={"15px"} color="#00394D" />
                <p className="font-bold text-sm text-[#00394D]">Back</p>
              </div>
              <div className="border border-solid border-[#E6EBED] mx-4 rounded-lg p-4">
                <div className="flex flex-row items-center gap-4">
                  {/* <img
                    src={
                      stocksInfo?.stock_details?.stock_logo
                        ? stocksInfo?.stock_details?.stock_logo
                        : hdfc
                    }
                    alt=""
                    className="w-[45px] h-[45px]"
                  /> */}
                  <Avatar
                    name={stocksInfo?.stock_details?.stock_name.split(" ")[0]}
                    round={true}
                    size="50"
                  />
                  <div className="flex flex-col gap-2 w-full">
                    <h2
                      title={stocksInfo?.stock_details?.stock_name}
                      className="text-lg font-semibold overflow-hidden whitespace-nowrap text-ellipsis w-[90%]"
                    >
                      {stocksInfo?.stock_details?.stock_name}
                    </h2>
                    <div className="flex flex-row gap-4 items-center">
                      <p className="font-bold text-lg">
                        &#8377; {stocksInfo?.stock_details?.current_value}
                      </p>
                      <p
                        className={`text-xs font-semibold ${
                          Math.sign(
                            stocksInfo?.stock_details?.per_day_value
                          ) === -1
                            ? "text-[#D30D00]"
                            : "text-[#47B971]"
                        }`}
                      >
                        {stocksInfo?.stock_details?.per_day_value}
                      </p>
                      <p
                        className={`text-xs font-semibold ${
                          Math.sign(
                            stocksInfo?.stock_details?.per_day_percent
                          ) === -1
                            ? "text-[#D30D00]"
                            : "text-[#47B971]"
                        }`}
                      >
                        {stocksInfo?.stock_details?.per_day_percent}%
                      </p>
                    </div>
                    <p className="text-xs font-medium text-[#8b8b8b]">
                      As on {stocksInfo?.stock_details?.as_on_date}
                    </p>
                  </div>
                </div>
                <div className="border-b border-solid border-[#F3F3F3] w-full my-4"></div>
                <div className="flex flex-col items-center gap-4">
                  <div className="flex flex-col w-full">
                    <p className="font-semibold text-sm text-[#333333] mb-3">
                      About Company
                    </p>
                    <p className="font-medium text-sm text-[#8B8B8B]">
                      {stocksInfo?.stock_details?.about_stock.slice(0, 500) +
                        "...."}
                    </p>
                  </div>
                  <div className="border-b border-solid border-[#F3F3F3] w-full"></div>
                  <div className="w-full">
                    <p className="font-semibold text-sm text-[#333333]">
                      Shareholding Pattern
                    </p>
                    {!chartDataError && (
                      <PieChart
                        data={updatedResponse}
                        options={graphOptions}
                      ></PieChart>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Right flexible part */}
            <div className="w-[72%]">
              {/* Content for the right part */}
              <StocksRight selectedStock={selectedStock} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Stocks;
